'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var _ = require('underscore');
var RadioItem = require('../common/RadioItem');
var propConst = require('../../constants/propConst');

/*
 * 单选按钮组件
 */
var RadioButton = React.createClass({

  getInitialState: function () {
    return {
      selected: appTypes.ComStatus.isSelected(this.props.state),
      disabled: appTypes.ComStatus.isDisabled(this.props.state)
    };
  },

  componentWillReceiveProps : function(newProps){
    var newSelected = appTypes.ComStatus.isSelected(newProps.state);
    var newDisabled = appTypes.ComStatus.isDisabled(newProps.state);
    if(newSelected !== this.state.selected || newDisabled !== this.state.disabled )
      this.setState({selected:newSelected})
  },

  render: function () {
    var state = styleHelper.getPropertyValue(this.props,propConst.STATE);
    var props = _.extend({},this.props);
    props.isSelected = this.state.selected;
    props.isDisabled = this.state.disabled;
    props.onSelected = this.onSelected;
    props.gap = 5;
    props.text = styleHelper.getText(this.props);
    if(props.stateProperties){
      props.isSelected = appTypes.ComStatus.isSelected(state);
      props.isDisabled = appTypes.ComStatus.isDisabled(state);
    }
    return (
      <RadioItem {...props}/>
    );
  },

  onSelected : function(){
    this.setState({selected : true});
  }
});

module.exports = RadioButton;



/** WEBPACK FOOTER **
 ** ./src/views/Components/RadioButton.jsx
 **/